module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-sub-cost-center/master-sub-cost-center.component.scss
// module id = ./src/app/master/master-sub-cost-center/master-sub-cost-center.component.scss
// module chunks = main